import React from "react";
import { Text, View } from "@react-pdf/renderer";

const RTABAKFooter = () => (
  <View
    fixed
    style={{
      position: "absolute",
      bottom: "30px",
      left: "30px",
      fontSize: "9px",
      display: "flex",
      flexDirection: "column",
      fontFamily: "Mont-Regular",
      color: "#303243",
      width: "100%",
      paddingTop: "14px",
      borderTop: "0.3px solid #303243",
    }}
  >
    <Text>Libertad 262 local 11</Text>
    <Text>Buenos aires - Argentina</Text>
    <Text>Tel.: +54(11)54118520 - info@rtabak.com.ar</Text>
  </View>
);

export default RTABAKFooter;
